import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HeaderComponent} from "./components/header/header.component";
import {FormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {MatDialogModule} from "@angular/material/dialog";
import {EmailValidatorDirective} from "fello-common";

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, FormsModule, HttpClientModule, MatDialogModule, EmailValidatorDirective],
  exports: [HeaderComponent, FormsModule, HttpClientModule, MatDialogModule, EmailValidatorDirective]
})
export class SharedModule {}
